module.exports = __webpack_public_path__ + "static/media/Icon_Case_studies_Opacity70.1238e615.png";